import React, { useEffect, useState } from 'react';
import { styled } from '@mui/material/styles';
import { DataGridPro, GridToolbarColumnsButton, GridToolbarContainer, GridToolbarDensitySelector, GridToolbarExport, GridToolbarFilterButton, useGridApiRef } from '@mui/x-data-grid-pro';
import { Button } from '@mui/material';
import dayjs from 'dayjs';
import { useSelector } from 'react-redux';
import { getCOValue, getNCOValue } from '../../reducer/LarvaIndexSlice';
import { getAreaSelected } from '../../reducer/areaSelectedSlice';
import { ExportMenu } from "./ExcelExport/ExportMenu";
import dotenv from 'react-dotenv';

const autoSizeOptions = {
    includeOutliers: true,
    includeHeaders: true,
    expand: true
}
const columns = [
    { field: 'moo', headerName: 'หมู่', width: 80 },
    { field: 'place_name', headerName: 'สถานที่', width: 160 },
    { field: 'place_type_name', headerName: 'ประเภทสถานที่', width: 160 },
    {   
        field: 'province_name', 
        headerName: 'จังหวัด', 
        valueFormatter: (params) => {
            if (params.value === "dummy") {
                return 'นอกประเทศ';
            }
            return params.value;
        },
        width: 160 },
    { 
        field: 'amphur_name', 
        headerName: 'อำเภอ',
        valueFormatter: (params) => {
            if (params.value === "dummy") {
                return 'นอกประเทศ';
            }
            return params.value;
        }, 
        width: 160 },
    { 
        field: 'tambon_name', 
        headerName: 'ตำบล', 
        valueFormatter: (params) => {
            if (params.value === "dummy") {
                return 'นอกประเทศ';
            }
            return params.value;
        },
        width: 160 },
    { 
        field: 'start_date', 
        headerName: 'วันที่เริ่มสำรวจ', 
        valueGetter: ({value}) => value && dayjs(value).toDate(),
        valueFormatter: (params) => {
            if (params.value === undefined) {
                return '-';
            }
            return `${dayjs(params.value).format('DD MMMM BBBB')}`;
        },
        type: 'date', 
        width: 160 },
    {  
        field: 'end_date', 
        headerName: 'วันที่สำรวจแล้วเสร็จ', 
        valueGetter: ({value}) => value && dayjs(value).toDate(),
        valueFormatter: (params) => {
            if (params.value === undefined) {
                return '-';
            }
            return `${dayjs(params.value).format('DD MMMM BBBB')}`;
        },
        type: 'date', 
        width: 160 },
    { field: 'inspected_container_count', headerName: '#ภาชนะที่สำรวจ', type: 'number', width: 160 },
    { field: 'infested_container_count', headerName: '#ภาชนะที่พบ', type: 'number', width: 160 },
    { field: 'inspected_building_count', headerName: '#บ้าน/อาคารที่สำรวจ', type: 'number', width: 160 },
    { field: 'infested_building_count', headerName: '#บ้าน/อาคารที่สำรวจพบ', type: 'number', width: 160 },
    { field: 'building_without_container', headerName: '#บ้าน/อาคารที่ไม่มีภาชนะขังน้ำ', type: 'number', width: 160 },
    { field: 'hi', headerName: 'HI', type: 'number', width: 80 },
    { field: 'ci', headerName: 'CI', type: 'number', width: 80 },
    { field: 'bi', headerName: 'BI', type: 'number', width: 80 },
]
const pinColumns = {left : ["place_name", "moo", "place_type_name"], right: ["hi", "ci", "bi"]}
function TableIndex() {
    const areaSelected = useSelector(getAreaSelected);
    const coValue = useSelector(getCOValue);
    const ncoValue = useSelector(getNCOValue);
    const [dataTable, setDataTable] = useState([]);
    // const [columns, setColumns] = useState([{ field: 'province_name', headerName: 'จังหวัด', width: 160 }]);
    // const [pinColumns, setPinColumns] = useState([]);
    const refTable = useGridApiRef();
    

    const StyledDataGrid = styled(DataGridPro)(({ theme }) => ({
        // borderStyle: 'solid',
        border: 0,
        // border: '1 solid #000000',
        color:
            theme.palette.mode === 'light' ? 'rgba(0,0,0,.85)' : 'rgba(255,255,255,0.85)',
        WebkitFontSmoothing: 'auto',
        letterSpacing: 'normal',
        '& .MuiDataGrid-columnsContainer': {
            backgroundColor: theme.palette.mode === 'light' ? '#fafafa' : '#1d1d1d',
        },
        '& .MuiDataGrid-iconSeparator': {
            // display: 'none',
        },
        '& .MuiDataGrid-columnHeaders': {
            borderTop: `1px solid ${theme.palette.mode === 'light' ? 'rgba(224, 224, 224, 1)' : '#303030'}`
        },
        '& .MuiDataGrid-columnHeader, .MuiDataGrid-cell': {
            borderRight: `1px solid ${theme.palette.mode === 'light' ? '#f0f0f0' : '#303030'}`,
        },
        '& .MuiDataGrid-columnsContainer, .MuiDataGrid-cell': {
            borderBottom: `1px solid ${theme.palette.mode === 'light' ? '#f0f0f0' : '#303030'}`,
        },
        '& .MuiDataGrid-cell': {
            color: theme.palette.mode === 'light' ? 'rgba(0,0,0,.85)' : 'rgba(255,255,255,0.65)',
        },
        '& .MuiPaginationItem-root': {
            borderRadius: 0,
        },
        // ...customCheckbox(theme),
    }));

    const CustomToolbar = () => {
        
        return (
            <GridToolbarContainer >
                <Button 
                    // variant="outlined"
                    onClick={() => {
                        // console.log(refTable.current);
                        refTable.current.autosizeColumns(autoSizeOptions);
                        // refTable.current.auto
                    }}
                >Auto Size</Button>
                <GridToolbarColumnsButton />
                <GridToolbarFilterButton />
                <GridToolbarDensitySelector />
                <ExportMenu options={{fileName: "index"}}/>
                {/* <GridToolbarExport /> */}
            </GridToolbarContainer>
        );
    }

    useEffect(() => {
        const filterData = async () => {
            if (areaSelected.level === 1) {
                setDataTable([...coValue, ...ncoValue]);
            } else {
                let tmpData = [...coValue, ...ncoValue];
                let outputData = [];
                let provinceList = [];
                if (areaSelected.level === 2) {
                    const response = await fetch(`${dotenv.MASTER_API_URL}/area/province?dpc_code=${areaSelected.value}`);
                    provinceList = await response.json();
                }
                for (let index = 0; index < tmpData.length; index++) {
                    const element = tmpData[index];
                    if (areaSelected.level === 2) {
                        let searchIndex = provinceList.findIndex(({ prov_code }) => prov_code === element.province_code);
                        if (searchIndex !== -1) {
                            outputData.push(element);
                        }
                    } else if (areaSelected.level === 3) {
                        if (element.province_code === areaSelected.value) {
                            outputData.push(element);
                        }
                    } else if (areaSelected.level === 4) {
                        if (element.amphur_code === areaSelected.value) {
                            outputData.push(element);
                        }
                    } else if (areaSelected.level === 5) {
                        if (element.tambon_code === areaSelected.value) {
                            outputData.push(element);
                        }
                    }   
                }
                setDataTable(outputData);
            }
        }
        if (coValue.length !== 0 || ncoValue.length !== 0) {
            filterData();
        }
    }, [coValue, ncoValue, areaSelected])

    const getRowId = (row) => {
        return row.survey_place_id;
    }

    return (
        <div style={{
            marginTop: 10,
            height: 'calc(100% - 10px)',
            // backgroundColor: 'red'
        }}>
            <StyledDataGrid
                apiRef={refTable}
                hideFooter
                rows={dataTable}
                columns={columns}
                initialState={{ pinnedColumns: pinColumns }}
                getRowId={getRowId}
                // autoHeight
                slots={{
                    toolbar: CustomToolbar
                }}
                autosizeOnMount
                autosizeOptions={autoSizeOptions}
            />
        </div>
    )
}

export default TableIndex
